import { currencyFormatter } from 'Pages/vehicles/helpers/formatNumberToGBPString';
import { type StateSlug, ForSaleCategory } from 'Types/enquiryStates';

type FormatVehicleOriginalPriceParams = {
	originalPrice?: number;
	price: number;
	slug: StateSlug;
};

export const formatVehicleOriginalPrice = ({
	originalPrice = 0,
	price,
	slug,
}: FormatVehicleOriginalPriceParams): string => {
	const isForSaleState = slug === ForSaleCategory.forSale || slug === ForSaleCategory.saleActive;
	const isPositiveDiscount = originalPrice > price;
	const shouldShowDiscount = isForSaleState && isPositiveDiscount;

	return !shouldShowDiscount ? '' : currencyFormatter.format(originalPrice);
};
